module.exports = __webpack_public_path__ + "static/media/big-gallery-1.34c6010a.jpg";